
export enum PayformActivityLocCd {
	ANY = 'Any',
	DEST = 'Dest',
	ENROUTE = 'Enroute',
	ORIGIN = 'Origin',
	UNKNOWN = 'Unknown'}

